import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class TermsOfUseController implements Controller {
  public pageId = 'TermsOfUse';
  public path = '/:localeName/terms-of-use';
  public routeName = 'terms-of-use';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "terms-of-use-page" */ '../views/terms-of-use-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Terms of Use' }) as Promise<PageData>;
  }
}
